import { render, staticRenderFns } from "./AllInactiveContacts.vue?vue&type=template&id=6e894321&"
import script from "./AllInactiveContacts.vue?vue&type=script&lang=js&"
export * from "./AllInactiveContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports